import * as ActionTypes from '../actions/actionTypes'

const initialState = {
    token: null,
    freshTokenPromise: null
}

/** @reducer **/
export default (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.LOGIN_SUCCESS:
            return {
                ...initialState,
                token: action.payload.token
            }
        case ActionTypes.LOGIN_FAILURE:
            return { ...initialState }
        case ActionTypes.LOGOUT:
            return { ...initialState }
        case ActionTypes.TOKEN_REFRESH_REQUEST:
            return {
                ...state,
                freshTokenPromise: action.freshTokenPromise
            }
        case ActionTypes.TOKEN_REFRESH_SUCCESS:
            return {
                ...state,
                token: action.payload.token,
                freshTokenPromise: null
            }
        case ActionTypes.TOKEN_REFRESH_FAILURE:
            return { ...initialState }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/authReducer.js